module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	<input type=\"text\" name=\"tracker\" />\n</div>\n\n<div class=\"row\">\n	<control type=\"datetimepicker\" target=\"params.fromDateTime\" html-name=\"from-date\" html-placeholder=\"с даты\"/>\n	<control type=\"datetimepicker\" target=\"params.toDateTime\" html-name=\"to-date\" html-placeholder=\"по даты\"/>\n\n	<div style=\"margin-top: 3px\">\n		<button on-click=\"onTodayClick\">Сегодня</button>\n		<button on-click=\"onYesterdayClick\">Вчера</button>\n	</div>\n</div>")
  }
  return __output.join("");

}